import { extendObservable, action } from 'mobx';

export class User {
  constructor(props = {}) {
    let {
      id = props.uid || "",
      name = "",
      email = "",
      phone = "",
      phoneVerified = false,
      stripeCustomerId = "",
      stripeSource = null,
    } = props;

    extendObservable(this, {
      id,
      name,
      email,
      phone: String(phone),
      phoneVerified,
      stripeCustomerId,
      stripeSource,
    });
  }

  set = action((props) => {
    if (!props) {
      return;
    }

    for (let key in props) {
      if (key in this) {
        this[key] = props[key];
      }
    }
  });

  get = () => {
    return JSON.parse(JSON.stringify(this));
  }

  hasPaymentMethod = () => {
    return !!(
      this.stripeSource &&
      typeof this.stripeSource === "object" &&
      this.stripeSource.id &&
      this.stripeSource.fingerprint
    );
  }
}

export default User;


// WEBPACK FOOTER //
// ./src/models/User.js